// frontend/src/pages/recommendationTotalWarning.js

/**
 * The warning a recommendation's estimated total carries, or null.
 *
 * Reads one row's data — a recommendation, or the pinned totals row (backend
 * `totals`). A total with no exchange rate is missing entirely, so that reason
 * wins over a count of uncosted lines, which the backend leaves null then.
 */
export function totalValueWarning(data, t) {
  if (data?.fx_unavailable) {
    return t('purchaseRecommendations.totalFxUnavailableTooltip');
  }
  const uncosted = data?.uncosted_lines;
  if (!uncosted) return null;
  return t('purchaseRecommendations.uncostedLinesTooltip', { count: uncosted });
}
